import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Korean%20manhwa%20illustration%20style%20epic%20panoramic%20scene%2C%20dramatic%20sky%20with%20warm%20golden%20and%20coral%20clouds%2C%20silhouettes%20of%20fantasy%20characters%20in%20flowing%20capes%2C%20magical%20particles%20floating%2C%20cinematic%20composition%2C%20rich%20contrast%20between%20light%20and%20shadow%2C%20emotional%20and%20breathtaking%20atmosphere&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape')`,
        }}
      >
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <p className="text-primary-200 text-sm md:text-base font-medium tracking-widest mb-4 animate-fade-in">
          —— 韩国漫画在线阅读平台 ——
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-4 max-w-3xl leading-tight">
          韩漫在线免费
          <span className="block text-2xl md:text-3xl lg:text-4xl font-normal mt-2 text-background-100">
            好看的韩国漫画大全
          </span>
        </h1>
        <p className="text-background-200 text-sm md:text-base max-w-xl mb-8 leading-relaxed">
          收录海量优质韩漫，支持下拉式阅读，随时随地享受精彩故事
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/romance"
            className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap shadow-lg hover:shadow-xl"
          >
            开始阅读
            <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white rounded-full text-sm font-semibold hover:bg-white/25 transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-3 gap-6 md:gap-12">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-primary-300">12,680+</p>
            <p className="text-xs md:text-sm text-background-300 mt-1">漫画作品</p>
          </div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-primary-300">850万+</p>
            <p className="text-xs md:text-sm text-background-300 mt-1">活跃读者</p>
          </div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-primary-300">320+</p>
            <p className="text-xs md:text-sm text-background-300 mt-1">每日更新</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>

      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in { animation: fade-in 1s ease-out; }
      `}</style>
    </section>
  );
}